import { FlatTreeControl } from '@angular/cdk/tree';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { NgxSpinnerService } from 'ngx-spinner';
import { timer } from 'rxjs';
import { IABMaster } from 'src/app/models/services/iab';

@Component({
  selector: 'eris-iab-master-tree',
  templateUrl: './iab-master-tree.component.html',
  styleUrls: ['./iab-master-tree.component.sass']
})
export class IabMasterTreeComponent implements OnInit, OnChanges {

  @Input() 
  data: IABMaster[];

  @Output() 
  onSelectedNodeChange = new EventEmitter<IABMaster>();

  selectedNodeId: number;
  filterTerm: string;
  filteredData: IABMaster[];

  private _transformer = (node: IABMaster, level: number) => {
    return {
      id: node.id,
      lakehouseId: node.lakehouseId,
      parentId: node.parentId,
      name: node.name,
      description: node.description,
      children: node.children,
      keywords: node.keywords,
      expandable: !!node.children && node.children.length > 0,
      level: level
    };
  };

  treeControl = new FlatTreeControl<IABMaster>(
    node => node.level,
    node => !node.children && node.children.length > 0,
  );

  treeFlattener = new MatTreeFlattener(
    this._transformer,
    node => node.level,
    node => node.expandable,
    node => node.children,
  );

  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  constructor(private spinnerService: NgxSpinnerService
  ) { 
  }

  ngOnInit(): void {
    this.filteredData = this.data;
    this.dataSource.data = this.filteredData;    
  }

  ngOnChanges(changes: SimpleChanges): void {
    var x = changes;  
  }

  hasChild = (_: number, node: IABMaster) => !!node.children && node.children.length > 0;

  selectNode = (node: IABMaster) => {
    this.selectedNodeId = node.id;
    this.onSelectedNodeChange.emit(node);
  }  

  filter = (searchBoxName: string, filterTerm: string) => {
    this.filterTerm = filterTerm;
    this.refreshGlobal();
  }

  refreshGlobal = () => {    
    this.spinnerService.show();
    let searchRegExp: RegExp = new RegExp(this.filterTerm, 'i');
    timer(100).subscribe(() => {
      let dataCopy: IABMaster[] = JSON.parse(JSON.stringify(this.data));
      if (this.filterTerm != '') {
        this.filterFullTaxonomy(dataCopy, searchRegExp);
        this.filteredData = dataCopy;
      } else {
        this.filteredData = this.data;
      }
      this.dataSource.data = this.filteredData;          
      this.spinnerService.hide();
    });  
  }

  filterFullTaxonomy = (taxonomyItems: IABMaster[], searchRegExp: RegExp): void => {    
    let i: number = 0;
    var sortLevel = true;
    while(i < taxonomyItems.length)
    {
      let item: IABMaster = taxonomyItems[i];
      if (!!item.children)
        this.filterFullTaxonomy(item.children, searchRegExp);      
      
      if (!item.description.match(searchRegExp) && (!item.children || item.children.length == 0))
        taxonomyItems.splice(i, 1);
      else
        i++;
    }

  }  
}
